'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaults = require('./defaults');

var _helpers = require('./helpers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Queue = function () {
    function Queue() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Queue);

        this.configure(config);
        this.queueTimer = null;
        this.startQueueTimer();
    }

    _createClass(Queue, [{
        key: 'configure',
        value: function configure(config) {
            var newConfig = {
                queueSize: (0, _helpers.validateQueueSize)(config.queueSize, _defaults.queue.queueSize),
                queueInterval: (0, _helpers.validateQueueInterval)(config.queueInterval, _defaults.queue.queueInterval)
            };

            this.queue = (0, _helpers.initializeQueue)(config.queueType);
            _extends(this, newConfig);
        }
    }, {
        key: 'startQueueTimer',
        value: function startQueueTimer() {
            var _this = this;

            if (!this.queueInterval) {
                return;
            }

            if (this.queueTimer !== null) {
                clearTimeout(this.queueTimer);
            }

            this.queueTimer = setTimeout(function () {
                return _this.drainQueue();
            }, this.queueInterval);
        }
    }, {
        key: 'addToQueue',
        value: function addToQueue(event) {
            this.queue.push(event);
            this.checkQueue();
        }
    }, {
        key: 'checkQueue',
        value: function checkQueue() {
            if (this.queue.length >= this.queueSize) {
                this.drainQueue();
                this.startQueueTimer();
            }
        }
    }, {
        key: 'setDrainCallback',
        value: function setDrainCallback(callback) {
            this.drainCallback = callback;
        }
    }, {
        key: 'drainQueue',
        value: function drainQueue() {
            if (this.queue.length > 0 && (0, _helpers.isFunction)(this.drainCallback)) {
                this.drainCallback(this.queue.splice(0, this.queue.length));
            }
        }
    }]);

    return Queue;
}();

exports.default = Queue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/Queue.js
// module id = 762
// module chunks = 0